import { Action } from 'redux';
import { GetPersonalSpace, GetPersonalSpaceSucceded } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { PersonalSpaceInfo } from '../../ts/restApi/personalSpace/PersonalSpace';

export interface GetPersonalSpaceAction extends Action {
}

export interface GetPersonalSpaceSuccededAction extends Action {
  personalSpace: PersonalSpaceInfo;
}

export function getPersonalSpace(): GetPersonalSpaceAction {
  return {
    type: GetPersonalSpace
  };
}

export const isGetPersonalSpaceAction = isActionFactory<GetPersonalSpaceAction>(GetPersonalSpace);

export function getPersonalSpaceSucceded(result: PersonalSpaceInfo): GetPersonalSpaceSuccededAction {
  return {
    type: GetPersonalSpaceSucceded,
    personalSpace: result
  };
}

export const isGetPersonalSpaceSuccededAction = isActionFactory<GetPersonalSpaceSuccededAction>(GetPersonalSpaceSucceded);
